import React from 'react';
import { ChatMessages, MessageComposer } from 'features/message-center';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPQuickView from 'UI/components/organisms/inventoryProfiles/FPQuickView';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { UIStatus } from 'UI/constants/status';
import { SvgNoMessages } from 'UI/res';

import { ChatContainer, MessageComposerContainer } from './ChatContent.styled';

export const ChatContent = ({
  chat,
  chatStatus,
  isQuickViewOpen,
  onClickRetry,
  onClickSend,
  onFetchMoreMessages,
  onMessageChange,
  selectedConversationInList,
  shouldScrollToBottom,
  toggleQuickViewOpen
}) => {
  const {
    entityId = '',
    entityType = '',
    externalNumber = '',
    fullName = ''
  } = selectedConversationInList || {};

  return !selectedConversationInList ? (
    <EmptyPlaceholder
      subtitle={strings.messageCenter.emptyState.unselected}
      customEmptyState={<SvgNoMessages height={300} />}
    />
  ) : (
    <>
      <ChatContainer aria-label="conversation messages">
        <ChatMessages
          chat={chat}
          chatStatus={chatStatus}
          onClickRetry={onClickRetry}
          onFetchMoreMessages={onFetchMoreMessages}
          shouldScrollToBottom={shouldScrollToBottom}
        />
      </ChatContainer>

      <MessageComposerContainer>
        <MessageComposer
          id={selectedConversationInList?.id}
          disabled={chatStatus !== UIStatus.Success}
          entityId={entityId}
          entityType={entityType}
          externalNumber={externalNumber}
          onClickSend={onClickSend}
          onMessageChange={onMessageChange}
          recipientFullName={fullName}
        />
      </MessageComposerContainer>

      <When condition={entityId && entityType && isQuickViewOpen}>
        <FPQuickView
          id={entityId}
          drawerProps={{
            open: isQuickViewOpen
          }}
          entityType={entityType}
          onClose={toggleQuickViewOpen}
        />
      </When>
    </>
  );
};
